import type { WikiTopic } from "../types.js";
import { factorsAndDeciles } from "./factors-and-deciles.js";
import { magnitudeAndLevels } from "./magnitude-and-levels.js";
import { sizeBands } from "./size-bands.js";

/**
 * The three topics about the numbers on a row, in reading order.
 *
 * Magnitude first because it is on every signal, then the deciles that only
 * factor rows carry, then the bands that filter both.
 */
export const conceptsMeasurement: readonly WikiTopic[] = [
  magnitudeAndLevels,
  factorsAndDeciles,
  sizeBands,
];
